import { Component, OnInit } from '@angular/core';
import { Dialog } from '../@core/interfaces/dialogs';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../@theme/components/dialog/dialog.component';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  opendia(){
    let dia : Dialog = {
      title:"Your Payment Information Succesfully Saved",
      icon: "icon-success-colored",
      content: "We will email you your membership account details as soon as possible",
      buttons:
        [{text:"OK",link:"home"}]
    };
    this.openDialog(dia);
  }
  opendia2(){
    let dia : Dialog = {
      title:"Sorry Registering New Student Branch is Currently Closed",
      icon: "",
      content: "",
      buttons:
        [{text:"OK",link:""}]
    };
    this.openDialog(dia);
  }
  opendia3(){
    let dia : Dialog = {
      title:"Your Payment Information Succesfully Saved",
      icon: "icon-success-colored",
      content: "We will email you your membership account details as soon as possible",
      buttons:
        [{text:"OK",link:"home"}]
    };
    this.openDialog(dia);
  }
  opendia4(){
    let dia : Dialog = {
      title:"Your Payment Information Succesfully Saved",
      icon: "icon-success-colored",
      content: "We will email you your membership account details as soon as possible",
      buttons:
        [{text:"OK",link:"home"}]
    };
    this.openDialog(dia);
  }

  openDialog(dialog: Dialog) {
    let dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: dialog
    });
  }

}
